
import React from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { DialogFooter } from "@/components/ui/dialog";
import { Task } from "../../../types/tasks";

interface TaskViewOnlyProps {
  task: Task;
  canMarkComplete: boolean;
  onUpdateTask: (task: Task) => void;
  onClose: () => void;
}

const TaskViewOnly = ({
  task,
  canMarkComplete,
  onUpdateTask,
  onClose,
}: TaskViewOnlyProps) => {

  const getStatusColor = (status: string) => {
    switch (status) {
      case "completed":
        return "bg-green-100 text-green-800 border-green-200";
      case "in_progress":
        return "bg-blue-100 text-blue-800 border-blue-200";
      case "pending":
        return "bg-amber-100 text-amber-800 border-amber-200";
      case "overdue":
        return "bg-red-100 text-red-800 border-red-200";
      default:
        return "bg-gray-100 text-gray-800 border-gray-200";
    }
  };

  return (
    <>
      <div>
        <h3 className="font-medium mb-1">{task.title}</h3>
        <p className="text-sm text-muted-foreground">{task.description}</p>
      </div>
      
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div>
          <p className="text-muted-foreground">Due Date</p>
          <p>{task.dueDate}</p>
        </div>
        
        <div>
          <p className="text-muted-foreground">Est. Time</p>
          <p>{task.estimatedTime}</p>
        </div>
        
        <div>
          <p className="text-muted-foreground">Status</p>
          <Badge variant="outline" className={getStatusColor(task.status)}>
            {task.status === "completed" ? "Completed" : 
             task.status === "in_progress" ? "In Progress" :
             task.status === "overdue" ? "Overdue" : "Pending"}
          </Badge>
        </div>
        
        <div>
          <p className="text-muted-foreground">Priority</p>
          <Badge>{task.priority}</Badge>
        </div>
      </div>
      
      <div className="text-sm">
        <p className="text-muted-foreground">Assigned to</p>
        {task.assignee ? (
          <div className="flex items-center mt-1">
            <div className="h-6 w-6 mr-2 rounded-full bg-primary/10 flex items-center justify-center">
              <span className="text-xs font-semibold text-primary">
                {task.assignee.name.split(' ').map(n => n[0]).join('')}
              </span>
            </div>
            <span>{task.assignee.name}</span>
          </div>
        ) : (
          <p>Unassigned</p>
        )}
      </div>
      
      <DialogFooter>
        {canMarkComplete && task.status !== "completed" && (
          <Button 
            variant="outline" 
            onClick={() => onUpdateTask({...task, status: "completed"})}
            className="mr-auto"
          >
            Mark Complete
          </Button>
        )}
        <Button variant="outline" onClick={onClose}>
          Close
        </Button>
      </DialogFooter>
    </>
  );
};

export default TaskViewOnly;
